export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/patients`,
        name: `${prefix}.patients.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patients.index`,
                PageDescription: "Accounts: Patient Listing",
            },
        },
    },
];
